module.exports = __webpack_public_path__ + "roadmap-301af0fc728602b2c406c51e200fe1d5.webp";